<template>
  <my-container>
    <main-title center wave>
      Контакты
    </main-title>
    <main-text
      class="mb-2 d-flex flex-column"
      v-for="(contact, k) in contactsData.contacts"
      :key="k"
    >
      <span class="font-weight-bold">{{ contact.name }}: </span>
      <span v-if="!contact.link">{{ contact.description }}</span>
      <a v-else :href="contact.link">
        {{ contact.description || contact.link }}
      </a>
    </main-text>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
        class="align-stretch"
        v-for="(teacher, k) in contactsData.teachers"
        :key="k"
      >
        <v-card class="fill-height">
          <v-img
            aspect-ratio="1"
            v-if="teacher.avatar"
            :src="teacher.avatar.thumbnail"
          ></v-img>
          <v-card-title>{{ getFullName(teacher) }}</v-card-title>
          <v-card-subtitle>
            <div>{{ teacherTypes[teacher.place] }}</div>

            <div v-if="teacher.phone">
              <span class="font-weight-bold">Телефон: </span>
              {{ teacher.phone }}
            </div>

            <div v-if="teacher.email">
              <span class="font-weight-bold">E-mail: </span>
              {{ teacher.email }}
            </div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        offset-md="1"
        md="10"
        v-for="(map, k) in contactsData.maps"
        :key="k"
      >
        <second-title center wave>
          {{ map.name }}
        </second-title>

        <v-card class="map-card">
          <div v-html="map.html"></div>
          <v-card-text>
            <second-text
              class="mb-2"
              center
              v-for="(description, k) in getRows(map.description)"
              :key="k"
              >{{ description }}</second-text
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </my-container>
</template>

<script>
import API from "@/common/api/api.functions";
import MyContainer from "@/components/MyContainer";
import MainTitle from "@/components/MainTitle";
import MainText from "@/components/MainText";
import { mapGetters } from "vuex";
import SecondTitle from "@/components/SecondTitle";
import SecondText from "@/components/SecondText";

export default {
  name: "Contacts",
  components: { SecondText, SecondTitle, MainText, MainTitle, MyContainer },
  data: () => ({
    contactsData: []
  }),
  computed: {
    ...mapGetters(["teacherTypes"])
  },
  methods: {
    async getContactsData() {
      this.contactsData = await API.getContacts().then(
        response => response.data
      );
    },
    getFullName(teacher) {
      let fullName = [];
      if (teacher.last_name) fullName = [...fullName, teacher.last_name];
      if (teacher.first_name) fullName = [...fullName, teacher.first_name];
      if (teacher.middle_name) fullName = [...fullName, teacher.middle_name];
      return fullName.join(" ");
    },
    getRows(item) {
      return item.split("\n") || "";
    }
  },
  mounted() {
    this.getContactsData();
  }
};
</script>

<style lang="scss">
.map-card {
  iframe {
    border: 0;
    width: 100%;
    min-height: 500px;
  }
}
</style>
